<template>
  <div class="form-group form-group--read-only">
    <div class="row">
      <div v-bind:class="`col-sm-${component.size}`">
        <label v-if="!component.hideLabel">{{ component.label }}</label>
        <div class="lead">
          <span class="prefix" v-if="component.prefix">{{ component.prefix }}</span>
          <span class="text" v-html="getValue" ></span>
          <span class="suffix" v-if="component.suffix">{{ component.suffix }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['component', 'components', 'value'],
  name: 'SelectApiReadOnly',
  computed: {
    getValue: function () {
      let valor = ''
      if (this.value) {
        this.value.forEach(function (item) {
          valor += ` ${item.label[0]} <br>`
        })
      } else {
        valor = '-'
      }
      return valor
    }
  }
}
</script>
